<template>
  <div class="page-productTkl">
    <div class="head-wrap" :style="{backgroundImage: `url(${headBgImg})`}"></div>
    <div class="inviter-wrap">
      <img class="avatar" :src="inviterAvatar" />
      <span class="nickname">【{{inviterName.length > 5 ? `${inviterName.substring(0, 4)}...` : inviterName}}】邀请您一起买</span>
      <span class="sale-count">{{productItem.saleCount}}人已购买</span>
    </div>
    <div class="goods-wrap">
      <div class="goods-img" :style="{backgroundImage: `url(${productItem.pic})`}"></div>
      <div class="goods-name">{{productItem.title}}</div>
      <div class="goods-price">
        <div class="money">
          <div class="buyPrice">
            券后价
            <span class="val">¥{{productItem.buyPrice}}</span>
          </div>
          <div class="marketPrice">¥{{productItem.marketPrice}}</div>
        </div>
        <div class="coupon" :style="{backgroundImage: `url(${couponImg})`}">
          <span class="label">{{productItem.coupon}}</span>元券
        </div>
      </div>
    </div>
    <div class="tkl-wrap">
      <div class="tkl-code" :style="{backgroundImage: `url(${tklBgImg})`}">{{productItem.tkl}}</div>
      <div class="btn-copy" :data-clipboard-text="productItem.tkl">
        <template v-if="!showSuccessCopy">一键复制</template>
        <template v-if="showSuccessCopy">
          复制成功，打开【
          <img :src="taobaoImg" />】购买
        </template>
      </div>
      <div class="copy-hint">
        点击【一键复制】上方内容，打开手机【
        <img :src="taobaoImg" />】购买
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
export default {
  name: 'productTkl',
  data() {
    return {
      headBgImg: require('../../assets/images/tkl/head_bg.png'), // 头图
      tklBgImg: require('../../assets/images/tkl/tkl_bg.png'), // 淘口令背景图
      taobaoImg: require('../../assets/images/tkl/icon_taobao.png'), // 淘宝小图标
      couponImg: require('../../assets/images/tkl/coupon.png'), // 优惠券图片
      inviterAvatar: '',
      inviterName: '',
      productItem: {
        buyPrice: '',
        pic: '',
        marketPrice: '',
        coupon: '',
        title: '',
        tkl: '',
        saleCount: '',
      },
      showSuccessCopy: false, // 显示复制成功
    }
  },
  mounted() {
    const clipboard = new Clipboard('.btn-copy')
    clipboard.on('success', e => {
      this.showSuccessCopy = true
      setTimeout(() => {
        this.showSuccessCopy = false
      }, 1500)
      e.clearSelection()
    })
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const params = this.$route.query
      // this.inviterAvatar = 'https://tupian.dshui.cc/94eb299de5a448b0bad89e3d2eaabdb620190527.jpg?x-oss-process=style/200'
      // this.inviterName = '苏哥'
      // this.productItem.buyPrice = '15.9'
      // this.productItem.pic = 'https://img.alicdn.com/bao/uploaded/i3/1604413269/O1CN01jhEkVM1a1FIm2sxWc_!!1604413269.jpg'
      // this.productItem.marketPrice = '69'
      // this.productItem.coupon = '10'
      // this.productItem.title = '长袖t恤女打底衫春秋装韩版学生宽松ins潮闺蜜装慵懒风中长款上衣'
      // this.productItem.tkl = '¢r3niYB3326w¢'
      // this.productItem.saleCount = '2万'
      this.inviterAvatar = params.inviterAvatar
      this.inviterName = params.inviterName
      this.productItem.buyPrice = params.buyPrice
      this.productItem.pic = params.pic
      this.productItem.marketPrice = params.marketPrice
      this.productItem.coupon = params.coupon
      this.productItem.title = params.title
      this.productItem.tkl = params.tkl
      this.productItem.saleCount = params.saleCount
    },
  },
}
</script>

<style lang="scss" scoped>
.page-productTkl {
  position: relative;
  overflow: hidden;
  min-height: 100%;
  background: #fff;
  padding: 0 0.32rem;
  .head-wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: auto;
    background: no-repeat center;
    background-size: cover;
    &:after {
      content: '';
      display: block;
      margin-top: percentage(549/750);
    }
  }
  .inviter-wrap {
    position: relative;
    display: flex;
    align-items: center;
    height: 1.4rem;
    font-size: 0.28rem;
    font-weight: 500;
    .avatar {
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
    }
    .nickname {
      margin-left: 0.12rem;
      color: #cfaa71;
    }
    .sale-count {
      margin-left: auto;
      color: #f4f4f4;
    }
  }
  .goods-wrap {
    .goods-img {
      box-shadow: 0 0 0.08rem #e2d4c0;
      box-sizing: border-box;
      background: no-repeat center;
      position: relative;
      overflow: hidden;
      background-size: cover;
      border-radius: 0.1rem;
      &:after {
        content: '';
        display: block;
        margin-top: 100%;
      }
    }
    .goods-name {
      color: #333333;
      height: 0.88rem;
      line-height: 0.88rem;
      font-size: 0.28rem;
      font-weight: bold;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .goods-price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
      .money {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow: hidden;
        .buyPrice {
          color: #333;
          font-size: 0.28rem;
          .val {
            margin-left: 0.1rem;
            color: #f42f19;
            font-size: 0.38rem;
            font-weight: 600;
          }
        }
        .marketPrice {
          display: inline-block;
          padding-top: 0.08rem;
          color: #969696;
          font-size: 0.26rem;
          text-decoration: line-through;
          margin-left: 0.1rem;
        }
      }
      .coupon {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        width: 1.64rem;
        height: 0.5rem;
        font-size: 0.26rem;
        background: center no-repeat;
        background-size: contain;
        white-space: nowrap;
        overflow: hidden;
        .label {
          font-size: 0.3rem;
        }
      }
    }
  }
  .tkl-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 0.32rem;
    overflow: hidden;
    .tkl-code {
      color: #b28f5a;
      width: 100%;
      height: 0.88rem;
      line-height: 0.88rem;
      text-align: center;
      font-size: 0.4rem;
      background: center no-repeat #f0f0f0;
      background-size: cover;
      border-radius: 0.04rem;
    }
    .btn-copy {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #2e313a;
      width: auto;
      padding: 0 0.44rem;
      height: 0.76rem;
      line-height: 0.76rem;
      text-align: center;
      font-size: 0.3rem;
      margin: 0.32rem 0;
      background-color: #cfaa71;
      border-radius: 0.76rem;
      cursor: pointer;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
      &:active {
        opacity: 0.3;
      }
    }
    .copy-hint {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #2e313a;
      font-size: 0.26rem;
      width: 100%;
      height: 0.88rem;
      background-color: #fff;
      white-space: nowrap;
      overflow: hidden;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
    }
  }
}
</style>
